import styled from "ibis-design-system/lib/HelperFunctions/ThirdParty/styled-components";

export const MarginTopBlock = styled.div`
    margin-top: 30px;
`;